(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-footer-controls]').forEach((controls) => {
    const footer = controls.closest('.footer-21-shell');
    const storageKey = 'footer-21-theme';

    const getSavedTheme = () => {
      try {
        return localStorage.getItem(storageKey);
      } catch (error) {
        return null;
      }
    };

    const saveTheme = (theme) => {
      try {
        localStorage.setItem(storageKey, theme);
      } catch (error) {
        // The toggle still works for the current view when storage is unavailable.
      }
    };

    const setFooterTheme = (theme) => {
      footer?.classList.toggle('footer-21-shell--light', theme === 'light');
      controls.querySelectorAll('[data-footer-theme]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.footerTheme === theme));
      });
      saveTheme(theme);
    };

    setFooterTheme(getSavedTheme() || 'dark');

    controls.querySelectorAll('[data-footer-theme]').forEach((button) => {
      button.addEventListener('click', () => setFooterTheme(button.dataset.footerTheme));
    });

    controls.querySelector('[data-footer-scroll-top]')?.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
